import { googleSdkLoaded } from "vue3-google-login";

// tg
export const generateUUID = async () => {
  const { data } = await api_getTgStartId();
  //@ts-ignore
  return data.value?.data?.start_id;

  // return new Promise(async (resolve, reject) => {
  //   try {
  //     resolve(res.data.start_id);
  //   } catch (err) {
  //     reject("error");
  //   }
  // });
  // const { res } = await api_getTgStartId();
  // let timestamp = new Date().getTime();
  // const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
  //   const r = (timestamp + Math.random() * 16) % 16 | 0;
  //   timestamp = Math.floor(timestamp / 16);
  //   return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  // });
};

export const getOpenNewWindowUrl = (uuid: string) => {
  const equipment = useEquipmentStore();
  // 新窗口的URL
  return `https://t.me/${equipment.telegram_bot_name}?start=` + uuid;
};

let curWindow: WindowProxy | null;
function openNewWindow(uuid: string) {
  // 新窗口的URL
  const url = getOpenNewWindowUrl(uuid);
  // 窗口的目标，'_blank'表示新窗口
  const target = "sv_tg";

  var features = "popup";

  // 打开新窗口
  curWindow = window.open(url, target, features);
  return curWindow;
}

// fb
export const facebookLogin = () => {
  return new Promise((resolve, reject) => {
    const user = useUserStore();
    initFacebookInit()
      ?.then(() => {
        window.FB.login((res: any) => {
          if (res.status === "connected") {
            // Logged into your webpage and Facebook.
            api_loginWithFacebook(res.authResponse.accessToken)
              .then(async ({ res: response }) => {
                await user.handLoginResponse({
                  ...response.data,
                  method: "facebook",
                });
                resolve(response);
              })
              .catch((err) => {
                reject(err);
              });
          }
        });
      })
      .catch((err) => {
        reject(err);
        console.log(err);
      });
  });
};
// pages\callback\facebook.vue
export const oauthFacebookLogin = (path: string) => {
  console.log("initFacebook");
  let str = `${import.meta.env.VITE_FACEBOOK_LOGIN_URL}?client_id=${
    import.meta.env.VITE_FACEBOOK_APP_ID
  }&redirect_uri=${import.meta.env.VITE_FACEBOOK_CALLBACK_URL}&state=${path}`;

  console.log("oauthFacebookLogin", str);
  location.href = str;
};

export const facebookCheckLogin = () => {
  return new Promise((resolve, reject) => {
    const user = useUserStore();

    initFacebookInit()
      ?.then(() => {
        window.FB.getLoginStatus(function (res: any) {
          console.log("getLoginStatus", res);
          if (res.status === "connected") {
            // Logged into your webpage and Facebook.
            api_loginWithFacebook(res.authResponse.accessToken)
              .then(async ({ res }) => {
                await user.handLoginResponse({
                  ...res.data,
                  method: "facebook",
                });
                resolve(res);
              })
              .catch((err) => {
                handlerNextStepFn();
              });
          }
        });
      })
      .catch((err) => {
        handlerNextStepFn();
        reject(err);
        console.log(err);
      });
  });
};

export const telegramLogin = async (
  type = "default",
  code = "",
  login_source = ""
) => {
  const user = useUserStore();
  const equipment = useEquipmentStore();
  return new Promise(async (resolve, reject) => {
    if (type === "once") {
      //手动登陆
      try {
        const { res } = await api_loginWithTelegram(code, login_source);
        console.log("telegram login res", res);
        equipment.tgSourceShowName = res.data.userInfo.sourceShowName;
        await user.handLoginResponse({
          ...res.data,
          method: "telegram",
          tgManualLogin: true,
        });
        resolve(res);
      } catch (error: any) {
        reject(error);
      }
    }
  });
};

/**
 * 获取window?.Telegram?.WebApp,判断platform是否是telegram
 * @returns 返回error/tg ,可以读取tg.initdata进行登录
 */
const getTgData = () => {
  const tg: any = window?.Telegram?.WebApp;
  console.log("window.Telegram.WebApp", tg);
  let res = {
    error: "",
    tg: "",
  };
  if (!tg) {
    console.log("no window.Telegram.WebApp");
    res.error = "notelegram";
    return res;
  }
  console.log("tg.platform", tg.platform);
  // 经过测试,window访问这个是null
  if (!tg.platform || tg.platform === "unknown") {
    res.error = "noplatform";
    return res;
  }
  res.tg = tg;
  tg.ready();
  return res;
};
export const autoLoginTelegramInit = (): Promise<boolean> => {
  console.log("telegarm _initTelegram");
  return new Promise(async (resolve, reject) => {
    const res: any = getTgData();
    if (res.error) {
      reject(res.error);
      return;
    }
    // 获取用户信息
    const initData: any = res?.tg?.initData;
    console.log("telegarm tg.initData", initData);
    if (initData) {
      try {
        let res = await telegramLogin("once", initData, "telegram_miniapp");
        resolve(true);
      } catch (error) {
        console.error("telegram login error:", error);
        reject("loginerror");
      }
    } else {
      console.log("no user info");
      reject("notoken");
    }
  });
};

declare global {
  interface Window {
    initTelegram?: Promise<boolean>;
    Telegram?: {
      WebApp?: {
        ready: () => void;
        initData?: any;
      };
    };
  }
}

// 在loginpopuppc里尝试绑定telegram的时候需要获取initdata作为code
export const getTelegramData = (): Promise<string> => {
  console.log("telegarm getTelegramData");
  return new Promise(async (resolve, reject) => {
    const res = getTgData();
    if (res.error) {
      reject(res.error);
      return;
    }
    // 获取用户信息
    const initData = res.tg.initData;
    resolve(initData);
  });
};

// tw
const openPopup = async (url: string): Promise<Window | null> => {
  return new Promise((resolve, reject) => {
    const w = 600;
    const h = 400;
    const left = screen.width / 2 - 600 / 2;
    const top = screen.height / 2 - 400 / 2;
    // safari中，对于接口返回的url，必须使用setTimeout进行跳转，否则窗口会被拦截
    // setTimeout(() => {
    resolve(
      window.open(
        url,
        "",
        "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
          w +
          ", height=" +
          h +
          ", top=" +
          top +
          ", left=" +
          left
      )
    );
    // });
  });
};

const polling = (
  popup: Window | null
): Promise<{ oauthVerifier: string; oauthToken: string }> => {
  return new Promise((resolve, reject) => {
    if (!popup) return reject("No popup dialog");
    const polling = setInterval(() => {
      if (!popup || popup.closed || popup.closed === undefined) {
        clearInterval(polling);
        return reject("Popup has been closed by user");
      }

      const closeDialog = () => {
        clearInterval(polling);
        popup.close();
      };

      try {
        if (
          !popup.location.hostname.includes("api.twitter.com") &&
          !popup.location.hostname.includes("api.x.com")
        ) {
          const query = new URLSearchParams(popup.location.search);
          const oauthToken = query.get("code") || "";
          const oauthVerifier = query.get("state") || "";
          if (popup.location.search && oauthToken && oauthVerifier) {
            closeDialog();
            return resolve({ oauthToken, oauthVerifier });
          }
        }
      } catch (error) {
        // Ignore DOMException: Blocked a frame with origin from accessing a cross-origin frame.
        // A hack to get around same-origin security policy errors in IE.
        console.log("poll", error);
      }
    }, 300);
  });
};

export const twitterLogin = () => {
  const user = useUserStore();
  return new Promise(async (resolve, reject) => {
    let popup: Window | null = null;

    try {
      const baseURL: string = useRuntimeConfig().public.apiBase;
      const authenticationUrl = `${baseURL}/auth/twitter/v2/authorize?callback=${location.origin}`;

      popup = await openPopup(authenticationUrl);

      const { oauthVerifier, oauthToken } = await polling(popup);

      await api_loginWithTwitter({
        oauthVerifier,
        oauthToken,
      }).then(async ({ res }) => {
        await user.handLoginResponse({ ...res.data, method: "twitter" });
        resolve(res);
      });
    } catch (error) {
      if (popup) popup.close();
      reject(error);
      console.log(error);
    }
  });
};

export const twitterBind = () => {
  const user = useUserStore();
  return new Promise(async (resolve, reject) => {
    let popup: Window | null = null;

    try {
      const baseURL: string = useRuntimeConfig().public.apiBase;
      const authenticationUrl = `${baseURL}/auth/twitter/v2/authorize?callback=${location.origin}`;

      popup = await openPopup(authenticationUrl);

      const { oauthVerifier, oauthToken } = await polling(popup);

      const { res } = await api_bindWithTwitter({
        oauthVerifier,
        oauthToken,
      });
      resolve(res);
    } catch (error) {
      if (popup) popup.close();
      reject(error);
      console.log(error);
    }
  });
};

// apple
export const appleLogin = async () => {
  const user = useUserStore();
  return new Promise(async (resolve, reject) => {
    console.log("window?.AppleID?.auth?.signIn", window?.AppleID);
    if (window?.AppleID?.auth?.signIn) {
      try {
        const response: any = await window.AppleID.auth.signIn();
        const { res } = await api_loginWithApple(
          response.authorization.id_token
        );

        await user.handLoginResponse({ ...res.data, method: "apple" });
        resolve(res);
      } catch (error) {
        handlerNextStepFn();

        reject(error);
        console.log(error);
      }
    } else {
      handlerNextStepFn();

      reject("failed to load apple login script");
    }
  });
};

export const appleBind = () => {
  return new Promise(async (resolve, reject) => {
    if (window?.AppleID?.auth?.signIn) {
      try {
        const response: any = await window.AppleID.auth.signIn();

        const { res } = await api_bindWithApple(
          response.authorization.id_token
        );

        resolve(res);
      } catch (error) {
        reject(error);
        console.log(error);
      }
    }
  });
};

//处理跳转逻辑
export const handlerNextStepFn = () => {
  const user = useUserStore();
  const equipment = useEquipmentStore();
  const route = useRoute();

  const redirectConfig = user.shareOpenConfig?.redirect;
  if (redirectConfig && Object.keys(redirectConfig).length) {
    let redirectUrl = "";

    let userAgent = "";
    if (import.meta.server) {
      const headers = useRequestHeaders();
      userAgent = headers["user-agent"] || "";
    } else {
      userAgent = window.navigator.userAgent;
    }

    if (equipment.isIOS(userAgent) && redirectConfig.iosurl) {
      redirectUrl = redirectConfig.iosurl as string;
    } else {
      redirectUrl = redirectConfig?.androidUrl;
    }

    if (redirectUrl) {
      const token = (route.query.svt as string) || user.token;

      let targetUrl = "";
      if (token && ["webapp", "share"].includes(redirectConfig.target)) {
        targetUrl = !redirectUrl.includes("?")
          ? redirectUrl + "?" + `svt=${token}`
          : redirectUrl + `&svt=${token}`;
      } else {
        targetUrl = redirectUrl;
      }

      if (import.meta.server && redirectConfig.mode !== "client") {
        const event = useRequestEvent();
        if (event) {
          event.res.statusCode = 301;
          event.res.setHeader("Location", targetUrl);
          event.res.end();
          return;
        }
      } else {
        if (import.meta.client) {
          navigateTo(targetUrl, { external: true });
        }
      }
    }
  }
};
